module.exports = function(amount) {
    this._sendMessage('amount', {type: 'set', value: amount});
};